import Highcharts from 'highcharts';
import $ from 'jquery';

import Language from '../language';
const lang = new Language();

export default function() {

	$('.js-fundd-tab > span').on('click', function(){
		$(this).addClass('current').siblings().removeClass('current');
		const index = $(this).index();
		$('.fundd-chart').removeClass('active');
		$('.fundd-chart').eq(index).addClass('active');
	});

	(() => {
		let myChart;
		$('.js-chart-tab-a > span').on('click', function(){
			$(this).addClass('current').siblings().removeClass('current');
			const dataArr = $(this).data('chart');
			// console.log(dataArr.categories, dataArr.data);
			// console.log('min', Math.min(...dataArr.data));

			let tickInterval = $(this).data('tickinterval');
			let rotation = undefined;
			if (!tickInterval) {
				tickInterval = 1
			} else {
				if (tickInterval == 6 && window.innerWidth > 1024) {
					rotation = 0;
				}
			}

			// console.log(rotation, tickInterval, 'sss');
			if (myChart) {
				myChart.destroy();
			}
			// myChart.update()
			myChart = Highcharts.chart('chartBoxA', getChartOption(dataArr.categories, dataArr.data, tickInterval, rotation));
		});



		const getChartOption = function(categories, data, tickInterval, rotation) {
			let min = Math.min(...data);
			min = min < 10000 ? min : 10000;
			return {
				chart: {
					type: 'area',
					backgroundColor: 'rgba(0,0,0,0)'
				},
				title: {
					text: ''
				},
				xAxis: {
					categories: categories,
					lineWidth: 1,
					lineColor: '#D0D0D0',
					tickWidth: 1, // 设置标记线宽度
					tickColor: '#707070',
					tickmarkPlacement: "on",
					tickInterval: tickInterval,
					labels: {
						rotation: rotation,
						style: {
							textOverflow: 'undefined'
						}
					},
					tickPositioner: function() {
						var positions = [],
							increment = Math.ceil((this.dataMax - this.dataMin) / this.categories.length);
						for (var i = this.dataMin; i <= this.dataMax + increment; i += increment) {
							positions.push(i);
						}
						positions[positions.length - 1] = this.dataMax; // 设置最后一个刻度为数据最大值
						return positions;
					}
				},
				yAxis: {
					title: {
						text: ''
					},
					min: min,
					tickInterval: 10000,
					lineWidth: 1,
					lineColor: '#D0D0D0',
					gridLineColor: '#D0D0D0'
				},
				plotOptions: {
					series: {
						pointPlacement: 'on' // 数据点放置在类别上
					}
				},
				series: [{
					name: '',
					data: data,
					color: '#004AC4',
					type: 'areaspline',
					threshold: null,
					label: {
						connectorAllowed: false
					},
					fillColor: {
						linearGradient: {
							x1: 0,
							y1: 0,
							x2: 0,
							y2: 1
						},
						stops: [
							[0, 'rgba(0, 74, 196, .3)'], // Start color
							[1, 'rgba(0, 74, 196, .01)']  // End color
						]
					},
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}],
				tooltip: {
					formatter: function() {
						return '<b>'+ lang.time +':</b> ' + this.x + '<br/>' + 
							'<b>'+ lang.price +':</b> ' + this.y;
					}
				},
				credits: {
					enabled: false // 禁用角标
				},
				legend: {
					enabled: false // 隐藏图例
				}
		}};

		const initData = $('.js-chart-tab-a span.current').data('chart');
		// console.log(initData);
		let tickInterval = $('.js-chart-tab-a span.current').data('tickinterval');
		let rotation = undefined;
		if (!tickInterval) {
			tickInterval = 1;
		} else {
			if (tickInterval == 6 && window.innerWidth > 1024) {
				rotation = 0;
			}
		}
		myChart = Highcharts.chart('chartBoxA', getChartOption(initData.categories, initData.data, tickInterval, rotation));
	})();

	// 
	(() => {

		const chartData = [];

		$('.js-chart-tab-b > span').each((index, item) => {
			const  d = $(item).data('chart');

			const categories = d.categories;
			const data = d.data;

			let newData = [];

			for (let i = 0; i < data.length; i++) {
				newData.push(data.slice(0, i+1).reduce((acc, num) => acc + num*100, 0) / 100);
			}


			d.data = newData;

			chartData.push(d)
			
		});

		$('.js-fundt-01').html(chartData[chartData.length-1].data[chartData[chartData.length-1].data.length - 1]);
		$('.js-fundt-02').html(chartData[chartData.length-2].data[chartData[chartData.length-2].data.length - 1]);


		let myChart;
		$('.js-chart-tab-b > span').on('click', function(){
			const index = $(this).index();
			$(this).addClass('current').siblings().removeClass('current');
			const dataArr = chartData[index];


			let tickInterval = $(this).data('tickinterval');
			let rotation = undefined;
			if (!tickInterval) {
				tickInterval = 1
			} else {
				if (tickInterval == 6 && window.innerWidth > 1024) {
					rotation = 0;
				}
			}

			console.log(rotation)

			if (myChart) {
				myChart.destroy();
			}

			myChart = Highcharts.chart('chartBoxB', getChartOption(dataArr.categories, dataArr.data, tickInterval, rotation));
		});

		

		const getChartOption = function(categories, data, tickInterval, rotation) {
			const min = Math.min(...data);
			return {
				chart: {
					type: 'area',
					backgroundColor: 'rgba(0,0,0,0)'
				},
				title: {
					text: ''
				},
				xAxis: {
					categories: categories,
					lineWidth: 1,
					lineColor: '#D0D0D0',
					tickWidth: 1, // 设置标记线宽度
					tickColor: '#707070',
					tickmarkPlacement: "on",
					tickInterval: tickInterval,
					labels: {
						rotation: rotation,
						style: {
							textOverflow: 'undefined'
						}
					},
					tickPositioner: function() {
						var positions = [],
							increment = Math.ceil((this.dataMax - this.dataMin) / this.categories.length);
						for (var i = this.dataMin; i <= this.dataMax + increment; i += increment) {
							positions.push(i);
						}
						positions[positions.length - 1] = this.dataMax; // 设置最后一个刻度为数据最大值
						return positions;
					}
				},
				yAxis: {
					title: {
						text: ''
					},
					min: 0,
					tickInterval: 25,
					lineWidth: 1,
					lineColor: '#D0D0D0',
					gridLineColor: '#D0D0D0'
				},
				plotOptions: {
					series: {
						pointPlacement: 'on' // 数据点放置在类别上
					}
				},
				series: [{
					name: '',
					data: data,
					color: '#004AC4',
					type: 'areaspline',
					threshold: null,
					label: {
						connectorAllowed: false
					},
					fillColor: {
						linearGradient: {
							x1: 0,
							y1: 0,
							x2: 0,
							y2: 1
						},
						stops: [
							[0, 'rgba(0, 74, 196, .3)'], // Start color
							[1, 'rgba(0, 74, 196, .01)']  // End color
						]
					},
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}],
				tooltip: {
					formatter: function() {
						return '<b>'+ lang.time +':</b> ' + this.x + '<br/>' + 
							'<b>'+ lang.rateOfReturn +':</b> ' + this.y + '%';
					}
				},
				credits: {
					enabled: false // 禁用角标
				},
				legend: {
					enabled: false // 隐藏图例
				}
		}};

		const initData = $('.js-chart-tab-b span.current').data('chart');
		console.log(initData);
		let tickInterval = $('.js-chart-tab-b span.current').data('tickinterval');
		let rotation = undefined;

		if (!tickInterval) {
			tickInterval = 1;
		} else {
			if (tickInterval == 6 && window.innerWidth > 1024) {
				rotation = 0;
			}
		}
		myChart = Highcharts.chart('chartBoxB', getChartOption(initData.categories, initData.data, tickInterval, rotation));
	})();
}